import React, { useCallback, useMemo, useState } from "react";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";

const MapPicker = ({
  defaultLocation,
  zoom,
  style,
  onChangeLocation,
  onChangeZoom,
  apiKey,
}) => {
  const [map, setMap] = useState(null);
  const [position, setPosition] = useState(defaultLocation);
  const center = useMemo(() => position || defaultLocation, [defaultLocation, position]);
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey,
  });

  const updateLocation = useCallback(
    (lat, lng) => {
      setPosition({ lat, lng });
      if (onChangeLocation) {
        onChangeLocation(lat, lng);
      }
    },
    [onChangeLocation]
  );

  if (!apiKey || !isLoaded) {
    return null;
  }

  return (
    <GoogleMap
      mapContainerStyle={style}
      center={center}
      zoom={zoom}
      onLoad={setMap}
      onClick={(event) => {
        if (!event.latLng) {
          return;
        }

        updateLocation(event.latLng.lat(), event.latLng.lng());
      }}
      onZoomChanged={() => {
        if (map && onChangeZoom) {
          onChangeZoom(map.getZoom());
        }
      }}
    >
      <MarkerF
        position={center}
        draggable
        onDragEnd={(event) => {
          if (!event.latLng) {
            return;
          }

          updateLocation(event.latLng.lat(), event.latLng.lng());
        }}
      />
    </GoogleMap>
  );
};

export default MapPicker;
